import type React from 'react';

import { Spinner, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { ResponsiveBox } from '#src/app/pages/petitionDetails/shared/components';
import { ScrollableComponent } from '#src/app/shared/components/layout/lazy';

import { PetitionUrlQRCode } from '../QRCode';

import { ShareLoader } from './ShareLoader';

export const SharePetition: React.FC<EmptyProps> = () => {
	return (
		<div className="px-0" data-qa="share-section">
			<Text as="h2" variant="heading" size="large">
				<Translate value="corgi.petition_gamma.share.title" />
			</Text>
			<ScrollableComponent immediateForBots>
				<div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
					<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
						<PetitionUrlQRCode />
					</ClientRender>
					<div className="w-full">
						<ResponsiveBox viewportSize="small">
							<ShareLoader forMobileView />
						</ResponsiveBox>
						<ResponsiveBox viewportSize="normal">
							<ShareLoader forMobileView={false} />
						</ResponsiveBox>
					</div>
				</div>
			</ScrollableComponent>
		</div>
	);
};
